import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericDecimalInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';


const CashClaimLimitInput: InputWithoutSource = ({ input }) => (
    <GenericDecimalInput label={input.name} input={input} />
);

CashClaimLimitInput.meta = {
    inputType: InputModel.name
};

export default observer(CashClaimLimitInput);
